import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import HttpReaderForm from '../forms/http-reader-form';
import { httpReaderValidationSchema } from '../schema/httpReader.js';

export default function HttpReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'HTTP Reader Node Details',
        altText: 'HTTP Reader Node',
        defaultLabel: 'HTTP Reader Node',
      }}
    >
      <CommonNode FormComponent={HttpReaderForm} schemaResolver={httpReaderValidationSchema} />
    </NodeProvider>
  );
}
